import React, { Component } from 'react'
import Firebase from 'firebase/app'
import 'firebase/auth'
import cclogotall from '../../images/cclogo-tall.png'
import {
  Image,
  Grid,
  Form,
  Step,
  Icon,
  Segment,
  Message
} from 'semantic-ui-react'
import PropTypes from 'prop-types'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: ''
    }
  }

  static propTypes = {
    history: PropTypes.object.isRequired
  }

  onChange = (_, { name, value }) => {
    this.setState({ [name]: value })
  }

  onSubmit = () => {
    this.setState({ loading: true })
    return Firebase.auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => this.setState({ loading: false }))
      .catch(({ message }) => {
        this.setState({
          error: message,
          loading: false
        })
      })
  }

  render() {
    return (
      <Grid stackable relaxed padded verticalAlign="middle" columns={3}>
        <Grid.Row reversed="mobile">
          <Grid.Column textAlign="center">
            <Image src={cclogotall} size="big" />
            <b>REAL-TIME PLAY-PREDICTION FOOTBALL GAME</b>
          </Grid.Column>
          <Grid.Column />
          <Grid.Column textAlign="center">
            <Segment>
              <Form
                error={Boolean(this.state.error)}
                onSubmit={this.onSubmit}
                loading={this.state.loading}
              >
                <h1>Login to CouchCoach</h1>
                <Message error header="Error" content={this.state.error} />
                <Form.Input
                  onChange={this.onChange}
                  name="email"
                  icon="mail"
                  iconPosition="left"
                  label="Email"
                  placeholder="Email"
                />
                <Form.Input
                  onChange={this.onChange}
                  type="password"
                  name="password"
                  icon="lock"
                  iconPosition="left"
                  label="Password"
                  placeholder="Password"
                />
                <Form.Button content="Login" color="orange" />
              </Form>
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            height: 100
          }}
        />
        <Grid.Row
          style={{
            marginBottom: 1
          }}
        >
          <Step.Group widths={3}>
            <Step>
              <Icon name="clipboard list" color="orange" />
              <Step.Content>
                <Step.Title>CHOOSE A GAME</Step.Title>
                <Step.Description>
                  Pick a game to join and wait for others to join.
                </Step.Description>
              </Step.Content>
            </Step>
            <Step>
              <Icon name="group" color="orange" />
              <Step.Content>
                <Step.Title>PICK YOUR TEAM</Step.Title>
                <Step.Description>
                  Pick the team you will be guessing for.
                </Step.Description>
              </Step.Content>
            </Step>
            <Step>
              <Icon name="football ball" color="orange" />
              <Step.Content>
                <Step.Title>PREDICT THE PLAY</Step.Title>
                <Step.Description>
                  You will be playing against others to guess which play offense
                  will run next.
                </Step.Description>
              </Step.Content>
            </Step>
          </Step.Group>
        </Grid.Row>
      </Grid>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/LoginScreen/index.jsx